import { render, staticRenderFns } from "./PrimaryMenu.vue?vue&type=template&id=06097eb6&scoped=true&"
import script from "./PrimaryMenu.vue?vue&type=script&lang=js&"
export * from "./PrimaryMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06097eb6",
  null
  
)

export default component.exports